import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IAIAssistantService } from '@src/slide/application/service/ai-ssistant/ai-ssistant-service.interface';
import {
    IMobileToolbarEditManager,
} from '@src/slide/application/service/mobile-toolbar-edit-manager/core/mobile-toolbar-edit-manager.interface';

export enum AiWritingSourceType {
    element = 'element',   // 选中元素（形状）
    textExpanded = 'textExpand', // 选中文字
    textEditing = 'textEditing', // 文本输入光标态（没有选中文字）
}


export interface IAIFloatManager {
    /**
     * ai组件是否打开
     */
    isOpen: boolean;
    /**
     * ai组件与画布交互时体现的高度
     */
    heightInCanvas: number;
    /**
     * 打开pc端ai组件
     * @param props
     */
    showAIModal(props: IInitAiFloatComponent): Promise<void>;

    /**
     * 打开mobile端ai组件
     * @param props
     */
    showMobileAIModal(props: IInitAiFloatComponent): Promise<void>;

    /**
     * 关闭ai组件
     */
    hideAiModal(params?: { ignoreCompleteTip: boolean }): void;

    /**
     * 打开pc端ai生成页
     * @param props
     */
    triggerGeneratePage(props: IInitAiFloatComponent): void;

    /**
     * 打开mobile端ai生成页
     * @param props
     */
    triggerGeneratePageMobile(props: IInitAiFloatComponent): void;

    /**
     * 获取ai编辑类型
     */
    getSourceType(): AiWritingSourceType | '';
}

/**
 * 组件启动参数
 */
export interface IInitAiFloatComponent {
    directShowPPTGeneration?: boolean; // 是否让组件在初始化完成后直接进入“生成页”状态
    positionWithSelection?: boolean; // 是否根据选择框决定组件位置
}

/**
 * 依赖服务
 */
export interface IAiFloatManagerDelegate {
    selectionService: ISelectionService;
    aiAssistantService: IAIAssistantService;
    mobileToolbarEditManager?: IMobileToolbarEditManager;
}
